import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { OptiService } from '../../opti.service';
import { EaselService } from '../../../maestros/easel/easel.service';
import { BendingMachineService } from '../../../maestros/bending_machine/bending_machine.service';
import { FileService } from '../../../file/file.service';

@Component({
  selector: 'app-production-planning',
  templateUrl: './production-planning.component.html'
})
export class ProductionPlanningComponent implements OnInit, OnDestroy {

  title: string;
  subtitle: string;
  mode: string;
  batchFilterForm: FormGroup;
  pendingFilterForm: FormGroup;
  batchRows: any[];
  batchTotal: number;
  batchPage: number;
  batchPageSize: number;
  batchItems: any[];
  pendingOrders: any[];
  pendingPositions: any[];
  pendingProductTypes: any[];
  selectedPendingOrder: any;
  selectedPendingPosition: any;
  pendingOrderSelection: {[key: string]: boolean};
  pendingPositionSelection: {[key: string]: boolean};
  addingPendingSelection: boolean;
  editingBatchNo: number;
  originalBatchNo: number;
  creatingBatch: boolean;
  optimizationStatus: string;
  requiredMaterials: number;
  optimizedMaterials: number;
  hasReadyMessages: boolean;
  readyMessagesCount: number;
  readyStepsCount: number;
  batchNumberModal: boolean;
  batchNumberLoading: boolean;
  batchNumberChecking: boolean;
  batchNumberInput: number;
  batchNumberModalMessage: string;
  loading: boolean;
  loadingPending: boolean;
  pendingLoadError: string;
  saving: boolean;
  auditModal: boolean;
  statusModal: boolean;
  modalBatchNo: number;
  auditRows: any[];
  statusRows: any[];
  message: string;
  messageSkin: string;
  planningHelpModal: boolean;
  planningHelpSection: string;
  planningHelpImageModal: boolean;
  planningHelpImageSrc: string;
  planningHelpImageTitle: string;
  planningTourModal: boolean;
  planningTourIndex: number;
  planningTourCardStyle: any;
  planningTourSpotlightStyle: any;
  planningTourPlacement: string;
  planningTourViewportHandler: any;
  planningTourKeydownHandler: any;
  classificationModal: boolean;
  classificationMode: number;
  classificationApplied: any;
  classificationManualItems: any[];
  classificationMode2Criteria: any[];
  classificationMode3Criteria: any[];
  classificationMode4Direction: string;
  classificationMode5MinimumSimilarity: number;
  classificationMode5KeepFirstGroup: boolean;
  printModal: boolean;
  printMode: string;
  printBatchNo: number;
  printUseTemporary: boolean;
  printPreparing: boolean;
  printIncludeGroupedProfiles: boolean;
  printDoubleGlazingAvailabilityKnown: boolean;
  printDoubleGlazingAvailable: boolean;
  printEasels: any[];
  selectedPrintEaselId: number;
  bendingMachines: any[];
  selectedBendingMachineId: number;
  bendingCodesModal: boolean;
  bendingCodesMissingRows: any[];
  bendingCodesLotList: number[];
  bendingCodesUseTemporary: boolean;
  bendingCodesMachineId: number;
  assistantLotProposalHandler: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private optiService: OptiService,
    private easelService: EaselService,
    private bendingMachineService: BendingMachineService,
    private fileService: FileService
  ) {}

  openBatchOptimizations(batchNoIn: any): void {
    const batchNo = Number(batchNoIn || 0);
    if (!Number.isInteger(batchNo) || batchNo <= 0) {
      this.showMessage('No hay un número de lote válido para buscar sus optimizaciones.', 'warning');
      return;
    }
    const filters = this.batchFilterForm && this.batchFilterForm.value ? this.batchFilterForm.value : {};
    this.router.navigate(['/opti_list', 'true'], {
      queryParams: {
        opti_lot: batchNo,
        source: 'production_planning',
        return_date_from: filters.f_date_from || '',
        return_date_to: filters.f_date_to || ''
      }
    });
  }

  ngOnInit() {
    this.title = 'Planificación';
    this.subtitle = 'Lotes de producción';
    this.mode = 'list';
    this.batchRows = [];
    this.batchTotal = 0;
    this.batchPage = 1;
    this.batchPageSize = 15;
    this.batchItems = [];
    this.pendingOrders = [];
    this.pendingPositions = [];
    this.pendingProductTypes = [];
    this.selectedPendingOrder = null;
    this.selectedPendingPosition = null;
    this.pendingOrderSelection = {};
    this.pendingPositionSelection = {};
    this.addingPendingSelection = false;
    this.editingBatchNo = null;
    this.originalBatchNo = null;
    this.creatingBatch = false;
    this.optimizationStatus = 'no';
    this.requiredMaterials = 0;
    this.optimizedMaterials = 0;
    this.hasReadyMessages = false;
    this.readyMessagesCount = 0;
    this.readyStepsCount = 0;
    this.batchNumberModal = false;
    this.batchNumberLoading = false;
    this.batchNumberChecking = false;
    this.batchNumberInput = null;
    this.batchNumberModalMessage = '';
    this.loading = false;
    this.loadingPending = false;
    this.pendingLoadError = '';
    this.saving = false;
    this.auditModal = false;
    this.statusModal = false;
    this.modalBatchNo = null;
    this.auditRows = [];
    this.statusRows = [];
    this.message = '';
    this.messageSkin = 'info';
    this.planningHelpModal = false;
    this.planningHelpSection = 'flujo';
    this.planningHelpImageModal = false;
    this.planningHelpImageSrc = '';
    this.planningHelpImageTitle = '';
    this.planningTourModal = false;
    this.planningTourIndex = 0;
    this.planningTourCardStyle = {};
    this.planningTourSpotlightStyle = {};
    this.planningTourPlacement = 'right';
    this.classificationModal = false;
    this.classificationMode = 1;
    this.classificationApplied = null;
    this.classificationManualItems = [];
    this.classificationMode2Criteria = this.getDefaultMode2Criteria();
    this.classificationMode3Criteria = this.getDefaultMode3Criteria();
    this.classificationMode4Direction = 'asc';
    this.classificationMode5MinimumSimilarity = 75;
    this.classificationMode5KeepFirstGroup = false;
    this.printModal = false;
    this.printMode = 'basic';
    this.printBatchNo = null;
    this.printUseTemporary = false;
    this.printPreparing = false;
    this.printIncludeGroupedProfiles = true;
    this.printDoubleGlazingAvailabilityKnown = false;
    this.printDoubleGlazingAvailable = false;
    this.printEasels = [];
    this.selectedPrintEaselId = null;
    this.bendingMachines = [];
    this.selectedBendingMachineId = null;
    this.bendingCodesModal = false;
    this.bendingCodesMissingRows = [];
    this.bendingCodesLotList = [];
    this.bendingCodesUseTemporary = false;
    this.bendingCodesMachineId = null;
    this.planningTourViewportHandler = () => {
      if (this.planningTourModal) {
        this.positionPlanningTourForCurrentStep();
      }
    };
    this.planningTourKeydownHandler = (eventIn: any) => {
      if (this.planningTourModal && eventIn && (eventIn.key === 'Escape' || eventIn.keyCode === 27)) {
        this.closePlanningTour();
      }
    };
    const returnedFromOptimizations = this.route.snapshot.queryParamMap.get('source') === 'optimization_list';
    const returnedDateFrom = this.route.snapshot.queryParamMap.get('f_date_from') || '';
    const returnedDateTo = this.route.snapshot.queryParamMap.get('f_date_to') || '';
    this.batchFilterForm = this.formBuilder.group({
      f_batchno: '',
      f_customer: '',
      f_date_from: returnedFromOptimizations ? returnedDateFrom : this.getDateInputValue(-7),
      f_date_to: returnedFromOptimizations ? returnedDateTo : this.getDateInputValue(0)
    });
    this.pendingFilterForm = this.formBuilder.group({
      f_customer: '',
      f_order: '',
      f_reference: '',
      f_product_type: ''
    });
    this.assistantLotProposalHandler = () => this.consumeAssistantLotProposal();
    window.addEventListener('dimpro-assist-production-lot', this.assistantLotProposalHandler);
    this.loadPrintOptions();
    if (!this.consumeAssistantLotProposal()) {
      this.searchBatches(1);
    }
  }

  ngOnDestroy(): void {
    this.closePlanningTour();
    if (this.assistantLotProposalHandler) {
      window.removeEventListener('dimpro-assist-production-lot', this.assistantLotProposalHandler);
    }
  }

  searchBatches(pageIn: number = 1): void {
    this.mode = 'list';
    this.loading = true;
    this.message = '';
    this.batchPage = Math.max(1, Number(pageIn || 1));
    const params = Object.assign({}, this.batchFilterForm.value, {
      page: this.batchPage,
      pagesize: this.batchPageSize
    });
    this.optiService.getProductionPlanningBatches(params).subscribe(response => {
      this.loading = false;
      this.batchRows = response && Array.isArray(response.data) ? response.data : [];
      this.batchTotal = response && response.count ? Number(response.count) : 0;
    });
  }

  clearBatchFilters(): void {
    this.batchFilterForm.patchValue({
      f_batchno: '',
      f_customer: '',
      f_date_from: this.getDateInputValue(-7),
      f_date_to: this.getDateInputValue(0)
    });
    this.searchBatches(1);
  }

  openCreate(): void {
    this.batchNumberModal = true;
    this.batchNumberLoading = true;
    this.batchNumberChecking = false;
    this.batchNumberInput = null;
    this.batchNumberModalMessage = '';
    this.optiService.getProductionPlanningNextBatch().subscribe(response => {
      if (!this.batchNumberModal) {
        return;
      }
      this.batchNumberLoading = false;
      if (!response || !response.next_batchno) {
        this.batchNumberModalMessage = 'No se ha podido obtener el siguiente número de lote disponible.';
        return;
      }
      this.batchNumberInput = Number(response.next_batchno);
    });
  }

  closeBatchNumberModal(): void {
    if (this.batchNumberChecking) {
      return;
    }
    this.batchNumberModal = false;
    this.batchNumberModalMessage = '';
  }

  confirmBatchNumber(): void {
    const batchNo = Number(this.batchNumberInput || 0);
    if (!Number.isInteger(batchNo) || batchNo <= 0) {
      this.batchNumberModalMessage = 'Introduzca un número de lote entero mayor que cero.';
      return;
    }
    this.batchNumberChecking = true;
    this.batchNumberModalMessage = '';
    this.optiService.getProductionPlanningNextBatch({ batchno: batchNo }).subscribe(response => {
      this.batchNumberChecking = false;
      if (!response) {
        this.batchNumberModalMessage = 'No se ha podido comprobar el número de lote.';
        return;
      }
      if (response.available !== true) {
        if (response.has_ready_messages) {
          this.batchNumberModalMessage = 'El lote ' + batchNo + ' ya tiene mensajes READY asociados y no se puede reutilizar.';
        } else {
          this.batchNumberModalMessage = 'El número de lote ' + batchNo + ' ya existe. Elija otro número.';
        }
        return;
      }
      this.batchNumberModal = false;
      this.beginCreate(batchNo);
    });
  }

  private beginCreate(batchNoIn: number): void {
    this.mode = 'edit';
    this.subtitle = 'Crear lote';
    this.resetClassificationState();
    this.creatingBatch = true;
    this.batchItems = [];
    this.pendingPositions = [];
    this.selectedPendingOrder = null;
    this.selectedPendingPosition = null;
    this.pendingOrderSelection = {};
    this.pendingPositionSelection = {};
    this.editingBatchNo = Number(batchNoIn);
    this.originalBatchNo = null;
    this.optimizationStatus = 'no';
    this.requiredMaterials = 0;
    this.optimizedMaterials = 0;
    this.hasReadyMessages = false;
    this.readyMessagesCount = 0;
    this.readyStepsCount = 0;
    this.message = '';
    this.searchPendingOrders();
  }

  private consumeAssistantLotProposal(): boolean {
    const storageKey = 'dimpro_assist_production_lot';
    const rawProposal = window.sessionStorage.getItem(storageKey);
    if (!rawProposal) {
      return false;
    }
    let proposal: any;
    try {
      proposal = JSON.parse(rawProposal);
    } catch (error) {
      window.sessionStorage.removeItem(storageKey);
      return false;
    }
    const positions = proposal && Array.isArray(proposal.positions)
      ? proposal.positions
      : [];
    if (positions.length === 0) {
      window.sessionStorage.removeItem(storageKey);
      return false;
    }
    if (this.mode !== 'list' && !window.confirm(
      'Hay un lote abierto en pantalla. Para revisar la propuesta de Dimpro Assist se descartará la edición no guardada. ¿Desea continuar?'
    )) {
      return false;
    }
    window.sessionStorage.removeItem(storageKey);
    this.loading = true;
    this.optiService.getProductionPlanningNextBatch().subscribe(response => {
      this.loading = false;
      const batchNo = Number(response && response.next_batchno || 0);
      if (!Number.isInteger(batchNo) || batchNo <= 0) {
        this.showMessage('No se ha podido reservar un número para revisar el lote propuesto por Dimpro Assist.', 'danger');
        this.searchBatches(1);
        return;
      }
      this.beginCreate(batchNo);
      positions.forEach(item => this.addBatchItem(item, false));
      this.resequenceBatchItems();
      this.openClassification();
      this.classificationMode = 5;
      this.classificationMode5MinimumSimilarity = Math.max(
        0,
        Math.min(100, Number(proposal.minimum_similarity) || 75)
      );
      this.applyClassification();
      const reason = proposal.selection_reason ? ' ' + proposal.selection_reason : '';
      this.showMessage(
        'Dimpro Assist ha preparado ' + positions.length +
        ' posición(es). Revisa el orden y las inclusiones antes de guardar.' + reason,
        'info'
      );
    });
    return true;
  }

  openEdit(rowIn: any): void {
    if (!rowIn || !rowIn.batchno) {
      return;
    }
    if (this.hasBatchReadyMessages(rowIn)) {
      this.showReadyBatchMessage(rowIn);
      return;
    }
    this.mode = 'edit';
    this.subtitle = 'Editar lote';
    this.resetClassificationState();
    this.creatingBatch = false;
    this.editingBatchNo = Number(rowIn.batchno);
    this.originalBatchNo = Number(rowIn.batchno);
    this.batchItems = [];
    this.pendingPositions = [];
    this.selectedPendingOrder = null;
    this.selectedPendingPosition = null;
    this.pendingOrderSelection = {};
    this.pendingPositionSelection = {};
    this.message = '';
    this.loading = true;
    this.optiService.getProductionPlanningBatch({ batchno: this.editingBatchNo }).subscribe(rows => {
      this.loading = false;
      this.batchItems = Array.isArray(rows) ? rows : [];
      this.applyOptimizationInfoFromRows(this.batchItems);
      this.resequenceBatchItems();
    });
    this.searchPendingOrders();
  }

  backToList(): void {
    if (this.saving) {
      return;
    }
    this.subtitle = 'Lotes de producción';
    this.mode = 'list';
    this.searchBatches(this.batchPage);
  }

  deleteBatch(rowIn: any): void {
    if (!rowIn || !rowIn.batchno) {
      return;
    }
    if (this.hasBatchReadyMessages(rowIn)) {
      this.showReadyBatchMessage(rowIn);
      return;
    }
    if (rowIn.optimization_status && rowIn.optimization_status !== 'no') {
      this.showMessage('El lote ' + rowIn.batchno + ' tiene optimizaciones asociadas (' + rowIn.optimization_status + '). Para modificarlo o eliminarlo antes hay que borrar esas optimizaciones.', 'warning');
      return;
    }
    const ok = window.confirm('Se eliminará la planificación del lote ' + rowIn.batchno + ' y sus posiciones volverán a quedar pendientes. ¿Desea continuar?');
    if (!ok) {
      return;
    }
    this.saving = true;
    this.optiService.deleteProductionPlanningBatch({ batchno: rowIn.batchno }).subscribe(response => {
      this.saving = false;
      if (!response || response.ok !== true) {
        this.showMessage(response && response.msg ? response.msg : 'No se ha podido eliminar el lote.', 'danger');
        return;
      }
      this.showMessage('Lote ' + rowIn.batchno + ' eliminado de la planificación.', 'info');
      this.searchBatches(this.batchPage);
    });
  }

  openAuditModal(rowIn: any): void {
    if (!rowIn || !rowIn.batchno) {
      return;
    }
    this.modalBatchNo = Number(rowIn.batchno);
    this.auditRows = [];
    this.auditModal = true;
    this.optiService.getProductionPlanningBatchAudit({ batchno: this.modalBatchNo }).subscribe(rows => {
      this.auditRows = Array.isArray(rows) ? rows : [];
    });
  }

  closeAuditModal(): void {
    this.auditModal = false;
  }

  openStatusModal(rowIn: any): void {
    if (!rowIn || !rowIn.batchno) {
      return;
    }
    this.modalBatchNo = Number(rowIn.batchno);
    this.statusRows = [];
    this.statusModal = true;
    this.optiService.getProductionPlanningBatchStatus({ batchno: this.modalBatchNo }).subscribe(rows => {
      this.statusRows = Array.isArray(rows) ? rows : [];
    });
  }

  closeStatusModal(): void {
    this.statusModal = false;
  }

  searchPendingOrders(): void {
    this.loadingPending = true;
    this.pendingLoadError = '';
    this.pendingPositions = [];
    this.selectedPendingOrder = null;
    this.selectedPendingPosition = null;
    this.pendingOrderSelection = {};
    this.pendingPositionSelection = {};
    this.optiService.getProductionPlanningPending(this.pendingFilterForm.value).subscribe(response => {
      this.loadingPending = false;
      if (response && response.load_error) {
        this.pendingOrders = [];
        this.pendingProductTypes = [];
        this.pendingLoadError = 'No se han podido cargar los pedidos pendientes. Reintenta la búsqueda o revisa la conexión.';
        return;
      }
      if (Array.isArray(response)) {
        this.pendingOrders = response;
        this.pendingProductTypes = this.buildPendingProductTypesFromRows(response);
      } else {
        this.pendingOrders = response && Array.isArray(response.data) ? response.data : [];
        this.pendingProductTypes = response && Array.isArray(response.product_types) ? response.product_types : [];
      }
    });
  }

  clearPendingFilters(): void {
    this.pendingFilterForm.patchValue({
      f_customer: '',
      f_order: '',
      f_reference: '',
      f_product_type: ''
    });
    this.searchPendingOrders();
  }

  changePendingProductType(): void {
    this.searchPendingOrders();
  }

  selectPendingOrder(rowIn: any): void {
    this.selectedPendingOrder = rowIn;
    this.selectedPendingPosition = null;
    this.pendingPositionSelection = {};
    this.pendingPositions = [];
    if (!rowIn || !rowIn.orderno) {
      return;
    }
    const requestedOrderNo = Number(rowIn.orderno);
    this.optiService.getProductionPlanningPendingPositions({
      orderno: requestedOrderNo,
      f_product_type: this.pendingFilterForm.controls.f_product_type.value || ''
    }).subscribe(rows => {
      if (!this.selectedPendingOrder || Number(this.selectedPendingOrder.orderno || 0) !== requestedOrderNo) {
        return;
      }
      this.pendingPositions = Array.isArray(rows) ? rows : [];
    });
  }

  selectPendingPosition(rowIn: any): void {
    this.selectedPendingPosition = rowIn;
    this.togglePendingPositionSelection(rowIn);
  }

  getPendingOrderSelectionKey(rowIn: any): string {
    return Number(rowIn && rowIn.orderno || 0).toString();
  }

  getPendingPositionSelectionKey(rowIn: any): string {
    return Number(rowIn && rowIn.orderno || 0) + '|' + Number(rowIn && rowIn.orderpos || 0);
  }

  isPendingOrderSelected(rowIn: any): boolean {
    const key = this.getPendingOrderSelectionKey(rowIn);
    return key !== '0' && this.pendingOrderSelection[key] === true;
  }

  isPendingPositionSelected(rowIn: any): boolean {
    const key = this.getPendingPositionSelectionKey(rowIn);
    return key !== '0|0' && this.pendingPositionSelection[key] === true;
  }

  togglePendingOrderSelection(rowIn: any): void {
    if (!rowIn || !rowIn.orderno || this.isOrderFullyAdded(rowIn)) {
      return;
    }
    const key = this.getPendingOrderSelectionKey(rowIn);
    if (this.pendingOrderSelection[key]) {
      delete this.pendingOrderSelection[key];
    } else {
      this.pendingOrderSelection[key] = true;
      this.selectPendingOrder(rowIn);
    }
  }

  togglePendingPositionSelection(rowIn: any): void {
    if (!rowIn || !rowIn.orderno || !rowIn.orderpos || this.hasBatchItem(rowIn.orderno, rowIn.orderpos)) {
      return;
    }
    const key = this.getPendingPositionSelectionKey(rowIn);
    if (this.pendingPositionSelection[key]) {
      delete this.pendingPositionSelection[key];
      if (this.samePosition(this.selectedPendingPosition, rowIn)) {
        this.selectedPendingPosition = null;
      }
    } else {
      this.pendingPositionSelection[key] = true;
      this.selectedPendingPosition = rowIn;
    }
  }

  toggleAllPendingOrders(): void {
    const selectable = this.getSelectablePendingOrders();
    if (selectable.length > 0 && this.areAllPendingOrdersSelected()) {
      this.pendingOrderSelection = {};
      return;
    }
    const selection = {};
    selectable.forEach(row => {
      selection[this.getPendingOrderSelectionKey(row)] = true;
    });
    this.pendingOrderSelection = selection;
  }

  toggleAllPendingPositions(): void {
    const selectable = this.getSelectablePendingPositions();
    if (selectable.length > 0 && this.areAllPendingPositionsSelected()) {
      this.pendingPositionSelection = {};
      this.selectedPendingPosition = null;
      return;
    }
    const selection = {};
    selectable.forEach(row => {
      selection[this.getPendingPositionSelectionKey(row)] = true;
    });
    this.pendingPositionSelection = selection;
    this.selectedPendingPosition = selectable.length > 0 ? selectable[selectable.length - 1] : null;
  }

  getSelectablePendingOrders(): any[] {
    return (this.pendingOrders || []).filter(row => !this.isOrderFullyAdded(row));
  }

  getSelectablePendingPositions(): any[] {
    return (this.pendingPositions || []).filter(row => !this.hasBatchItem(row.orderno, row.orderpos));
  }

  getSelectedPendingOrders(): any[] {
    return this.getSelectablePendingOrders().filter(row => this.isPendingOrderSelected(row));
  }

  getSelectedPendingPositions(): any[] {
    return this.getSelectablePendingPositions().filter(row => this.isPendingPositionSelected(row));
  }

  getSelectedPendingOrderCount(): number {
    return this.getSelectedPendingOrders().length;
  }

  getSelectedPendingPositionCount(): number {
    return this.getSelectedPendingPositions().length;
  }

  areAllPendingOrdersSelected(): boolean {
    const selectable = this.getSelectablePendingOrders();
    return selectable.length > 0 && selectable.every(row => this.isPendingOrderSelected(row));
  }

  areAllPendingPositionsSelected(): boolean {
    const selectable = this.getSelectablePendingPositions();
    return selectable.length > 0 && selectable.every(row => this.isPendingPositionSelected(row));
  }

  isPendingOrderSelectionPartial(): boolean {
    const selected = this.getSelectedPendingOrderCount();
    return selected > 0 && !this.areAllPendingOrdersSelected();
  }

  isPendingPositionSelectionPartial(): boolean {
    const selected = this.getSelectedPendingPositionCount();
    return selected > 0 && !this.areAllPendingPositionsSelected();
  }

  addSelectedOrders(): void {
    if (!this.canModifyCurrentBatch()) {
      this.showCurrentBatchLockedMessage();
      return;
    }
    const selectedOrders = this.getSelectedPendingOrders();
    if (selectedOrders.length === 0) {
      this.showMessage('Seleccione uno o varios pedidos pendientes.', 'warning');
      return;
    }
    const orderNumbers = selectedOrders
      .map(row => Number(row && row.orderno || 0))
      .filter(orderNo => orderNo > 0);
    if (orderNumbers.length === 0) {
      this.showMessage('No hay pedidos válidos en la selección.', 'warning');
      return;
    }
    this.addingPendingSelection = true;
    this.optiService.getProductionPlanningPendingPositions({
      ordernos: orderNumbers.join(','),
      f_product_type: this.pendingFilterForm.controls.f_product_type.value || ''
    }).subscribe(rows => {
      this.addingPendingSelection = false;
      const positions = Array.isArray(rows) ? rows : [];
      const previousCount = this.batchItems.length;
      positions.forEach(item => this.addBatchItem(item, false));
      this.resequenceBatchItems();
      this.pendingOrderSelection = {};
      this.pendingPositionSelection = {};
      this.selectedPendingPosition = null;
      const addedCount = this.batchItems.length - previousCount;
      if (addedCount > 0) {
        this.showMessage(
          'Se han añadido ' + addedCount + ' posición(es) de ' + selectedOrders.length + ' pedido(s) al lote.',
          'info'
        );
      } else {
        this.showMessage('Todas las posiciones seleccionadas ya estaban incluidas en el lote.', 'warning');
      }
    });
  }

  addSelectedPositions(): void {
    if (!this.canModifyCurrentBatch()) {
      this.showCurrentBatchLockedMessage();
      return;
    }
    const selectedPositions = this.getSelectedPendingPositions();
    if (selectedPositions.length === 0) {
      this.showMessage('Seleccione una o varias posiciones del pedido.', 'warning');
      return;
    }
    const previousCount = this.batchItems.length;
    selectedPositions.forEach(item => this.addBatchItem(item, false));
    this.resequenceBatchItems();
    this.pendingPositionSelection = {};
    this.selectedPendingPosition = null;
    const addedCount = this.batchItems.length - previousCount;
    this.showMessage('Se han añadido ' + addedCount + ' posición(es) al lote.', addedCount > 0 ? 'info' : 'warning');
  }

  addBatchItem(rowIn: any, resequenceIn: boolean): void {
    if (!rowIn || !rowIn.orderno || !rowIn.orderpos) {
      return;
    }
    if (this.hasBatchItem(rowIn.orderno, rowIn.orderpos)) {
      return;
    }
    const copy = Object.assign({}, rowIn);
    copy.batchseq = this.batchItems.length + 1;
    this.batchItems.push(copy);
    if (resequenceIn) {
      this.resequenceBatchItems();
    }
  }

  removeBatchItem(rowIn: any): void {
    if (!this.canModifyCurrentBatch()) {
      this.showCurrentBatchLockedMessage();
      return;
    }
    if (!rowIn) {
      return;
    }
    this.batchItems = this.batchItems.filter(item => !this.samePosition(item, rowIn));
    this.resequenceBatchItems();
  }

  hasBatchItem(orderNoIn: any, orderPosIn: any): boolean {
    const orderNo = Number(orderNoIn || 0);
    const orderPos = Number(orderPosIn || 0);
    return this.batchItems.some(item => Number(item.orderno || 0) === orderNo && Number(item.orderpos || 0) === orderPos);
  }

  samePosition(aIn: any, bIn: any): boolean {
    return Number(aIn && aIn.orderno || 0) === Number(bIn && bIn.orderno || 0) &&
      Number(aIn && aIn.orderpos || 0) === Number(bIn && bIn.orderpos || 0);
  }

  isOrderFullyAdded(rowIn: any): boolean {
    if (!rowIn || !rowIn.orderno) {
      return false;
    }
    const totalPositions = Number(rowIn.positions_count || 0);
    const added = this.batchItems.filter(item => Number(item.orderno || 0) === Number(rowIn.orderno || 0)).length;
    return totalPositions > 0 && added >= totalPositions;
  }

  resequenceBatchItems(): void {
    let includedSequence = 0;
    this.batchItems.forEach((item, index) => {
      if (this.mode === 'classify' && !this.isClassificationItemIncluded(item)) {
        item.batchseq = null;
        return;
      }
      includedSequence += 1;
      item.batchseq = this.mode === 'classify' ? includedSequence : index + 1;
    });
  }

  openClassification(): void {
    if (!this.canModifyCurrentBatch()) {
      this.showCurrentBatchLockedMessage();
      return;
    }
    if (!this.editingBatchNo || this.batchItems.length === 0) {
      this.showMessage('Debe añadir al menos una posición antes de clasificar el lote.', 'warning');
      return;
    }
    this.classificationManualItems = this.batchItems.slice();
    this.classificationManualItems.forEach((item, index) => {
      item._planningManualPosition = index + 1;
      item._planningIncluded = true;
    });
    this.classificationMode = 1;
    this.classificationApplied = {
      mode: 1,
      criteria: []
    };
    this.mode = 'classify';
    this.subtitle = 'Clasificar lote';
    this.message = '';
  }

  backToBatchEditor(): void {
    if (this.saving || this.printPreparing) {
      return;
    }
    this.classificationModal = false;
    this.batchItems = this.getPlanningIncludedBatchItems();
    this.mode = 'edit';
    this.resequenceBatchItems();
    this.subtitle = this.creatingBatch ? 'Crear lote' : 'Editar lote';
  }

  isClassificationItemIncluded(rowIn: any): boolean {
    return !!rowIn && rowIn._planningIncluded !== false;
  }

  getPlanningIncludedBatchItems(): any[] {
    return (this.batchItems || []).filter(item => this.isClassificationItemIncluded(item));
  }

  getPlanningExcludedBatchItemCount(): number {
    return (this.batchItems || []).length - this.getPlanningIncludedBatchItems().length;
  }

  areAllClassificationItemsIncluded(): boolean {
    return this.batchItems.length > 0 &&
      this.batchItems.every(item => this.isClassificationItemIncluded(item));
  }

  isClassificationInclusionPartial(): boolean {
    const includedCount = this.getPlanningIncludedBatchItems().length;
    return includedCount > 0 && includedCount < this.batchItems.length;
  }

  toggleClassificationItem(rowIn: any): void {
    if (!rowIn || !this.canModifyCurrentBatch()) {
      return;
    }
    rowIn._planningIncluded = !this.isClassificationItemIncluded(rowIn);
    this.moveExcludedClassificationItemsToEnd();
  }

  toggleAllClassificationItems(): void {
    if (!this.canModifyCurrentBatch() || this.batchItems.length === 0) {
      return;
    }
    const includeAll = !this.areAllClassificationItemsIncluded();
    this.batchItems.forEach(item => {
      item._planningIncluded = includeAll;
    });
    this.moveExcludedClassificationItemsToEnd();
  }

  private moveExcludedClassificationItemsToEnd(): void {
    const included = this.getPlanningIncludedBatchItems();
    const excluded = (this.batchItems || []).filter(item => !this.isClassificationItemIncluded(item));
    this.batchItems = included.concat(excluded);
    this.resequenceBatchItems();
  }

  openClassificationModal(): void {
    if (!this.canModifyCurrentBatch() || this.batchItems.length === 0) {
      return;
    }
    this.classificationModal = true;
  }

  closeClassificationModal(): void {
    this.classificationModal = false;
  }

  selectClassificationMode(modeIn: number): void {
    const mode = Number(modeIn || 1);
    this.classificationMode = mode >= 1 && mode <= 5 ? mode : 1;
  }

  getDefaultMode2Criteria(): any[] {
    return [
      { key: 'route', label: 'Ruta de entrega', selected: true, direction: 'asc' },
      { key: 'customer', label: 'Nº cliente', selected: true, direction: 'asc' },
      { key: 'order', label: 'Nº pedido', selected: true, direction: 'asc' },
      { key: 'reference', label: 'Referencia de línea', selected: true, direction: 'asc' },
      { key: 'largestSide', label: 'Lado mayor', selected: true, direction: 'desc' }
    ];
  }

  getDefaultMode3Criteria(): any[] {
    return [
      { key: 'cuttingDifficulty', label: 'Dificultad de corte', selected: true, direction: 'asc' },
      { key: 'largestSide', label: 'Lado mayor', selected: true, direction: 'desc' }
    ];
  }

  moveClassificationCriterion(criteriaIn: any[], indexIn: number, movementIn: number): void {
    if (!criteriaIn || indexIn < 0 || indexIn >= criteriaIn.length) {
      return;
    }
    const targetIndex = indexIn + movementIn;
    if (targetIndex < 0 || targetIndex >= criteriaIn.length) {
      return;
    }
    const moved = criteriaIn.splice(indexIn, 1)[0];
    criteriaIn.splice(targetIndex, 0, moved);
  }

  getSelectedCriterionPriority(criteriaIn: any[], indexIn: number): number {
    if (!criteriaIn || !criteriaIn[indexIn] || criteriaIn[indexIn].selected !== true) {
      return 0;
    }
    let priority = 0;
    for (let index = 0; index <= indexIn; index++) {
      if (criteriaIn[index] && criteriaIn[index].selected === true) {
        priority += 1;
      }
    }
    return priority;
  }

  canApplyClassification(): boolean {
    if (this.classificationMode === 2) {
      return this.classificationMode2Criteria.some(item => item.selected === true);
    }
    if (this.classificationMode === 3) {
      return this.classificationMode3Criteria.some(item => item.selected === true);
    }
    return true;
  }

  applyClassification(): void {
    if (!this.canApplyClassification()) {
      this.showMessage('Seleccione al menos un criterio de ordenación.', 'warning');
      return;
    }
    const excluded = (this.batchItems || []).filter(item => !this.isClassificationItemIncluded(item));
    if (this.getPlanningIncludedBatchItems().length === 0) {
      this.showMessage('Active al menos una posición para poder ordenar el lote.', 'warning');
      return;
    }

    let ordered = this.getPlanningIncludedBatchItems();
    let appliedCriteria: any[] = [];

    if (this.classificationMode === 1) {
      const manualPosition = {};
      this.classificationManualItems.forEach((item, index) => {
        manualPosition[this.getBatchItemKey(item)] = index;
      });
      ordered.sort((a, b) => {
        return Number(manualPosition[this.getBatchItemKey(a)] || 0) -
          Number(manualPosition[this.getBatchItemKey(b)] || 0);
      });
    } else if (this.classificationMode === 2) {
      appliedCriteria = this.classificationMode2Criteria
        .filter(item => item.selected === true)
        .map(item => Object.assign({}, item));
      ordered = this.sortByPlanningCriteria(ordered, appliedCriteria);
    } else if (this.classificationMode === 3) {
      appliedCriteria = this.classificationMode3Criteria
        .filter(item => item.selected === true)
        .map(item => Object.assign({}, item));
      ordered = this.sortByPlanningCriteria(ordered, appliedCriteria);
    } else if (this.classificationMode === 4) {
      ordered = this.sortByWorkSteps(ordered, this.classificationMode4Direction);
      appliedCriteria = [{
        key: 'workSteps',
        label: 'Pasos de trabajo',
        selected: true,
        direction: this.classificationMode4Direction
      }, {
        key: 'largestSide',
        label: 'Lado mayor (desempate)',
        selected: true,
        direction: 'desc',
        fixed: true
      }];
    } else {
      ordered = this.groupByProductionTime(ordered, this.classificationMode5MinimumSimilarity);
      appliedCriteria = [{
        key: 'timeCompatibility',
        label: 'Homogeneidad del tiempo',
        selected: true,
        direction: 'desc'
      }, {
        key: 'productionTime',
        label: 'Tiempo de producción',
        selected: true,
        direction: 'asc',
        fixed: true
      }];
      if (this.classificationMode5KeepFirstGroup) {
        ordered.forEach(item => item._planningIncluded = Number(item._planningTimeGroup || 0) === 1);
      }
    }

    this.batchItems = ordered.concat(excluded);
    this.resequenceBatchItems();
    this.classificationApplied = {
      mode: this.classificationMode,
      criteria: appliedCriteria
    };
    this.classificationModal = false;
    this.showMessage('Se ha aplicado ' + this.getClassificationModeLabel(this.classificationMode) + '.', 'info');
  }

  private sortByPlanningCriteria(rowsIn: any[], criteriaIn: any[]): any[] {
    const stableRows = (rowsIn || []).map((row, index) => ({ row, index }));
    stableRows.sort((a, b) => {
      for (const criterion of criteriaIn) {
        const compared = this.comparePlanningValues(
          this.getPlanningCriterionValue(a.row, criterion.key),
          this.getPlanningCriterionValue(b.row, criterion.key),
          criterion.key,
          criterion.direction
        );
        if (compared !== 0) {
          return compared;
        }
      }
      return a.index - b.index;
    });
    return stableRows.map(item => item.row);
  }

  private sortByWorkSteps(rowsIn: any[], directionIn: string): any[] {
    const direction = directionIn === 'desc' ? -1 : 1;
    const stableRows = (rowsIn || []).map((row, index) => ({ row, index }));
    stableRows.sort((a, b) => {
      const countA = this.getWorkStepCount(a.row);
      const countB = this.getWorkStepCount(b.row);
      if (countA !== countB) {
        return (countA - countB) * direction;
      }
      const stepsCompared = this.compareNaturalText(this.getWorkSteps(a.row), this.getWorkSteps(b.row));
      if (stepsCompared !== 0) {
        return stepsCompared * direction;
      }
      const sideCompared = this.getLargestSide(b.row) - this.getLargestSide(a.row);
      if (sideCompared !== 0) {
        return sideCompared;
      }
      return a.index - b.index;
    });
    return stableRows.map(item => item.row);
  }

  private getProductionTimeVector(rowIn: any): {[key: string]: number} {
    const vector: {[key: string]: number} = {};
    (Array.isArray(rowIn && rowIn.time_vector) ? rowIn.time_vector : []).forEach(item => {
      const key = item && item.step ? item.step.toString().trim().toUpperCase() : '';
      if (key) vector[key] = Number(vector[key] || 0) + Math.max(0, Number(item.seconds || 0));
    });
    if (Object.keys(vector).length === 0) vector.CORTE = this.getProductionTimeSeconds(rowIn);
    return vector;
  }

  getProductionTimeSimilarity(leftIn: any, rightIn: any): number {
    const leftStatus = this.getProductionTimeStatus(leftIn);
    const rightStatus = this.getProductionTimeStatus(rightIn);
    if (leftStatus === 'UNCONFIGURED' || rightStatus === 'UNCONFIGURED' || leftStatus !== rightStatus) {
      return 0;
    }
    const leftTotal = this.getProductionTimeSeconds(leftIn);
    const rightTotal = this.getProductionTimeSeconds(rightIn);
    const maxTotal = Math.max(leftTotal, rightTotal, 1);
    const totalDistance = Math.abs(leftTotal - rightTotal) / maxTotal;
    const leftVector = this.getProductionTimeVector(leftIn);
    const rightVector = this.getProductionTimeVector(rightIn);
    const keys = Array.from(new Set(Object.keys(leftVector).concat(Object.keys(rightVector))));
    let compositionDistance = 0;
    keys.forEach(key => {
      const leftShare = leftTotal > 0 ? Number(leftVector[key] || 0) / leftTotal : 0;
      const rightShare = rightTotal > 0 ? Number(rightVector[key] || 0) / rightTotal : 0;
      compositionDistance += Math.abs(leftShare - rightShare);
    });
    compositionDistance = Math.min(1, compositionDistance / 2);
    return Math.max(0, Math.min(100, Number(((1 - (totalDistance * .6 + compositionDistance * .4)) * 100).toFixed(1))));
  }

  private groupByProductionTime(rowsIn: any[], minimumSimilarityIn: number): any[] {
    const minimum = Math.max(0, Math.min(100, Number(minimumSimilarityIn || 75)));
    const groups: Array<{ seed: any, rows: any[] }> = [];
    (rowsIn || []).forEach(row => {
      let selectedGroup = -1;
      let selectedSimilarity = -1;
      groups.forEach((group, index) => {
        const similarity = this.getProductionTimeSimilarity(group.seed, row);
        if (similarity >= minimum && similarity > selectedSimilarity) {
          selectedGroup = index;
          selectedSimilarity = similarity;
        }
      });
      if (selectedGroup < 0) {
        groups.push({ seed: row, rows: [row] });
        selectedGroup = groups.length - 1;
        selectedSimilarity = this.getProductionTimeStatus(row) === 'UNCONFIGURED' ? 0 : 100;
      } else {
        groups[selectedGroup].rows.push(row);
      }
      row._planningTimeGroup = selectedGroup + 1;
      row._planningTimeSimilarity = selectedSimilarity;
    });
    return groups.reduce((result, group, groupIndex) => {
      group.rows.sort((left, right) => {
        const similarity = Number(right._planningTimeSimilarity || 0) - Number(left._planningTimeSimilarity || 0);
        if (similarity !== 0) return similarity;
        return this.getProductionTimeSeconds(left) - this.getProductionTimeSeconds(right);
      });
      group.rows.forEach(row => row._planningTimeGroup = groupIndex + 1);
      return result.concat(group.rows);
    }, []);
  }

  private comparePlanningValues(aIn: any, bIn: any, keyIn: string, directionIn: string): number {
    const emptyA = aIn === null || aIn === undefined || aIn === '';
    const emptyB = bIn === null || bIn === undefined || bIn === '';
    if (emptyA || emptyB) {
      if (emptyA && emptyB) {
        return 0;
      }
      return emptyA ? 1 : -1;
    }

    let compared = 0;
    if (keyIn === 'customer' || keyIn === 'order' || keyIn === 'largestSide' || keyIn === 'cuttingDifficulty') {
      compared = Number(aIn || 0) - Number(bIn || 0);
    } else {
      compared = this.compareNaturalText(aIn.toString(), bIn.toString());
    }
    return directionIn === 'desc' ? compared * -1 : compared;
  }

  private compareNaturalText(aIn: string, bIn: string): number {
    return (aIn || '').localeCompare((bIn || ''), 'es', {
      sensitivity: 'base',
      numeric: true
    });
  }

  private getPlanningCriterionValue(rowIn: any, keyIn: string): any {
    if (keyIn === 'route') {
      return rowIn && rowIn.ruta_exp ? rowIn.ruta_exp.toString().trim() : '';
    }
    if (keyIn === 'customer') {
      return Number(rowIn && rowIn.end_customer_id || 0);
    }
    if (keyIn === 'order') {
      return Number(rowIn && rowIn.orderno || 0);
    }
    if (keyIn === 'reference') {
      return this.getReference(rowIn);
    }
    if (keyIn === 'largestSide') {
      return this.getLargestSide(rowIn);
    }
    if (keyIn === 'cuttingDifficulty') {
      return this.getCuttingTime(rowIn);
    }
    return '';
  }

  getLargestSide(rowIn: any): number {
    return Math.max(Number(rowIn && rowIn.width || 0), Number(rowIn && rowIn.height || 0));
  }

  getCuttingTime(rowIn: any): number {
    return Math.max(0, Number(rowIn && rowIn.cutting_time || 0));
  }

  getProductionTimeSeconds(rowIn: any): number {
    return Math.max(0, Number(rowIn && rowIn.production_time_seconds || 0));
  }

  getProductionTimeStatus(rowIn: any): string {
    const status = rowIn && rowIn.time_status ? rowIn.time_status.toString().toUpperCase() : '';
    if (status === 'CALCULATED' || status === 'ESTIMATED' || status === 'UNCONFIGURED') return status;
    return this.getProductionTimeSeconds(rowIn) > 0 ? 'ESTIMATED' : 'UNCONFIGURED';
  }

  getProductionTimeStatusLabel(rowIn: any): string {
    const status = this.getProductionTimeStatus(rowIn);
    if (status === 'CALCULATED') return 'Tiempo calculado';
    if (status === 'ESTIMATED') return 'Tiempo estimado';
    return 'Sin configuración';
  }

  getProductionTimeStatusSkin(rowIn: any): string {
    const status = this.getProductionTimeStatus(rowIn);
    if (status === 'CALCULATED') return 'success';
    if (status === 'ESTIMATED') return 'warning';
    return 'danger';
  }

  getProductionTimeStatusDetail(rowIn: any): string {
    if (rowIn && rowIn.time_status_detail) return rowIn.time_status_detail.toString();
    const status = this.getProductionTimeStatus(rowIn);
    if (status === 'CALCULATED') return 'Fotografía completa del motor de tiempos.';
    if (status === 'ESTIMATED') return 'Estimación auxiliar: revise su fiabilidad antes de planificar.';
    return 'No existe información suficiente para planificar por tiempos.';
  }

  getProductionTimeStatusCount(statusIn: string): number {
    const status = (statusIn || '').toString().toUpperCase();
    return (this.batchItems || []).filter(row => this.getProductionTimeStatus(row) === status).length;
  }

  getProductionTimeTitle(rowIn: any): string {
    const parts = [this.getProductionTimeStatusDetail(rowIn)];
    if (rowIn && rowIn.time_profile) parts.push(rowIn.time_profile.toString());
    return parts.filter(item => !!item).join(' · ');
  }

  formatProductionTime(secondsIn: any): string {
    const seconds = Math.max(0, Math.round(Number(secondsIn || 0)));
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainder = seconds % 60;
    if (hours > 0) return hours + ' h ' + minutes + ' min';
    if (minutes > 0) return minutes + ' min ' + remainder + ' s';
    return remainder + ' s';
  }

  getBatchProductionTimeSeconds(): number {
    return this.getPlanningIncludedBatchItems().reduce((total, row) => total + this.getProductionTimeSeconds(row), 0);
  }

  private getBatchProductionStepLoads(): Array<{ step: string, seconds: number }> {
    const loads: {[key: string]: { step: string, seconds: number }} = {};
    this.getPlanningIncludedBatchItems().forEach(row => {
      const vector = Array.isArray(row && row.time_vector) && row.time_vector.length > 0
        ? row.time_vector
        : (this.getProductionTimeSeconds(row) > 0
          ? [{ step: 'CORTE (ESTIMADO)', seconds: this.getProductionTimeSeconds(row) }]
          : []);
      vector.forEach(item => {
        const step = item && item.step ? item.step.toString().trim() : 'SIN PASO';
        const key = step.toUpperCase();
        if (!loads[key]) loads[key] = { step, seconds: 0 };
        loads[key].seconds += Math.max(0, Number(item && item.seconds || 0));
      });
    });
    return Object.keys(loads)
      .map(key => ({ step: loads[key].step, seconds: Number(loads[key].seconds.toFixed(3)) }))
      .sort((left, right) => right.seconds - left.seconds);
  }

  getBatchElapsedProductionTimeSeconds(): number {
    const loads = this.getBatchProductionStepLoads();
    return loads.length > 0 ? loads[0].seconds : 0;
  }

  getBatchBottleneckStepName(): string {
    const loads = this.getBatchProductionStepLoads();
    return loads.length > 0 ? loads[0].step : '';
  }

  getWorkSteps(rowIn: any): string {
    return rowIn && rowIn.work_steps ? rowIn.work_steps.toString().trim() : '';
  }

  getWorkStepCount(rowIn: any): number {
    const provided = Number(rowIn && rowIn.work_step_count || 0);
    if (provided > 0) {
      return provided;
    }
    const steps = this.getWorkSteps(rowIn);
    return steps ? steps.split(' - ').filter(step => step.trim() !== '').length : 0;
  }

  getBatchItemKey(rowIn: any): string {
    return Number(rowIn && rowIn.orderno || 0) + '|' + Number(rowIn && rowIn.orderpos || 0);
  }

  getClassificationModeLabel(modeIn: number = null): string {
    const mode = Number(modeIn || (this.classificationApplied && this.classificationApplied.mode) || 1);
    if (mode === 2) {
      return 'Orden multicriterio';
    }
    if (mode === 3) {
      return 'Dificultad de corte';
    }
    if (mode === 4) {
      return 'Pasos de trabajo';
    }
    if (mode === 5) {
      return 'Tiempo de producción homogéneo';
    }
    return 'Orden manual';
  }

  getClassificationModeSkin(modeIn: number = null): string {
    const mode = Number(modeIn || (this.classificationApplied && this.classificationApplied.mode) || 1);
    if (mode === 2) {
      return 'info';
    }
    if (mode === 3) {
      return 'warning';
    }
    if (mode === 4) {
      return 'success';
    }
    if (mode === 5) {
      return 'primary';
    }
    return 'dark';
  }

  getClassificationCriterionSkin(keyIn: string): string {
    if (keyIn === 'route') {
      return 'link';
    }
    if (keyIn === 'customer') {
      return 'primary';
    }
    if (keyIn === 'order') {
      return 'info';
    }
    if (keyIn === 'reference') {
      return 'dark';
    }
    if (keyIn === 'largestSide') {
      return 'success';
    }
    if (keyIn === 'cuttingDifficulty') {
      return 'warning';
    }
    if (keyIn === 'workSteps') {
      return 'success';
    }
    if (keyIn === 'timeCompatibility' || keyIn === 'productionTime') {
      return 'primary';
    }
    return 'light';
  }

  getAppliedClassificationCriteria(): any[] {
    return this.classificationApplied && Array.isArray(this.classificationApplied.criteria)
      ? this.classificationApplied.criteria
      : [];
  }

  getDirectionLabel(directionIn: string): string {
    return directionIn === 'desc' ? 'DESC' : 'ASC';
  }

  getClassificationEvidence(rowIn: any): any[] {
    if (!this.isClassificationItemIncluded(rowIn)) {
      return [{
        key: 'excluded',
        label: 'Estado',
        value: 'Fuera del lote',
        skin: 'danger'
      }];
    }
    const appliedMode = Number(this.classificationApplied && this.classificationApplied.mode || 1);
    if (appliedMode === 1) {
      return [{
        key: 'manual',
        label: 'Selección',
        value: '#' + Number(rowIn && rowIn._planningManualPosition || rowIn && rowIn.batchseq || 0),
        skin: 'dark'
      }];
    }
    if (appliedMode === 4) {
      return [{
        key: 'workSteps',
        label: this.getWorkStepCount(rowIn) + ' pasos',
        value: this.getWorkSteps(rowIn) || 'Sin pasos',
        skin: 'success'
      }, {
        key: 'largestSide',
        label: 'Lado mayor',
        value: this.formatNumber(this.getLargestSide(rowIn)) + ' mm',
        skin: 'info'
      }];
    }
    if (appliedMode === 5) {
      return [{
        key: 'timeStatus',
        label: 'Fiabilidad',
        value: this.getProductionTimeStatusLabel(rowIn),
        skin: this.getProductionTimeStatusSkin(rowIn)
      }, {
        key: 'timeCompatibility',
        label: 'Grupo homogéneo ' + Number(rowIn && rowIn._planningTimeGroup || 0),
        value: this.formatNumber(rowIn && rowIn._planningTimeSimilarity || 0, 1) + '% compatible',
        skin: 'primary'
      }, {
        key: 'productionTime',
        label: 'Tiempo',
        value: this.getProductionTimeStatus(rowIn) === 'UNCONFIGURED'
          ? 'No disponible'
          : this.formatProductionTime(this.getProductionTimeSeconds(rowIn)),
        skin: 'info'
      }, {
        key: 'workSteps',
        label: 'Vector',
        value: rowIn && rowIn.time_profile ? rowIn.time_profile : (this.getWorkSteps(rowIn) || 'Sin cálculo detallado'),
        skin: 'success'
      }];
    }
    return this.getAppliedClassificationCriteria().map(criterion => ({
      key: criterion.key,
      label: criterion.label,
      value: this.formatClassificationCriterionValue(rowIn, criterion.key),
      skin: this.getClassificationCriterionSkin(criterion.key)
    }));
  }

  formatClassificationCriterionValue(rowIn: any, keyIn: string): string {
    if (keyIn === 'route') {
      return rowIn && rowIn.ruta_exp ? rowIn.ruta_exp.toString() : 'Sin ruta';
    }
    if (keyIn === 'customer') {
      return Number(rowIn && rowIn.end_customer_id || 0).toString();
    }
    if (keyIn === 'order') {
      return Number(rowIn && rowIn.orderno || 0).toString();
    }
    if (keyIn === 'reference') {
      return this.getReference(rowIn) || 'Sin referencia';
    }
    if (keyIn === 'largestSide') {
      return this.formatNumber(this.getLargestSide(rowIn)) + ' mm';
    }
    if (keyIn === 'cuttingDifficulty') {
      return this.formatNumber(this.getCuttingTime(rowIn), 2) + ' min';
    }
    if (keyIn === 'workSteps') {
      return this.getWorkSteps(rowIn) || 'Sin pasos';
    }
    if (keyIn === 'timeCompatibility') {
      return this.formatNumber(rowIn && rowIn._planningTimeSimilarity || 0, 1) + '%';
    }
    if (keyIn === 'productionTime') {
      return this.formatProductionTime(this.getProductionTimeSeconds(rowIn));
    }
    return '';
  }

  resetClassificationState(): void {
    this.classificationModal = false;
    this.classificationMode = 1;
    this.classificationApplied = null;
    this.classificationManualItems = [];
    this.classificationMode2Criteria = this.getDefaultMode2Criteria();
    this.classificationMode3Criteria = this.getDefaultMode3Criteria();
    this.classificationMode4Direction = 'asc';
    this.classificationMode5MinimumSimilarity = 75;
    this.classificationMode5KeepFirstGroup = false;
  }

  private loadPrintOptions(): void {
    this.easelService.getEasels({ setup_user: 'Cut', f_type: 3, f_active: false }).subscribe(rows => {
      this.printEasels = Array.isArray(rows) ? rows.slice().sort((a, b) => {
        const priorityA = Number(a && a.priority !== undefined && a.priority !== null ? a.priority : 999);
        const priorityB = Number(b && b.priority !== undefined && b.priority !== null ? b.priority : 999);
        if (priorityA !== priorityB) {
          return priorityB - priorityA;
        }
        return Number(a && a.id || 0) - Number(b && b.id || 0);
      }) : [];
      if (!this.selectedPrintEaselId && this.printEasels.length > 0) {
        this.selectedPrintEaselId = Number(this.printEasels[0].id);
      }
    });
    this.bendingMachineService.getBendingMachines({}).subscribe(rows => {
      this.bendingMachines = (Array.isArray(rows) ? rows : []).filter(item => {
        return item && (item.active === true || Number(item.active) === 1);
      });
      if (!this.selectedBendingMachineId && this.bendingMachines.length > 0) {
        this.selectedBendingMachineId = Number(this.bendingMachines[0].id);
      }
    });
  }

  openPlanningPrint(batchNoIn: any, useTemporaryIn: boolean): void {
    const batchNo = Number(batchNoIn || this.editingBatchNo || 0);
    if (!batchNo) {
      this.showMessage('No hay un número de lote válido para imprimir.', 'warning');
      return;
    }
    this.printBatchNo = batchNo;
    this.printUseTemporary = useTemporaryIn === true;
    this.printMode = 'basic';
    this.printIncludeGroupedProfiles = true;
    const doubleGlazingAvailable = this.resolveDoubleGlazingAvailability(batchNo, this.printUseTemporary);
    this.printDoubleGlazingAvailabilityKnown = doubleGlazingAvailable !== null;
    this.printDoubleGlazingAvailable = doubleGlazingAvailable === true;
    this.printPreparing = false;
    this.printModal = true;
  }

  closePlanningPrint(): void {
    if (this.printPreparing) {
      return;
    }
    this.printModal = false;
  }

  planningPrintNeedsEasel(): boolean {
    return this.printMode === 'route_dispatch' || this.printMode === 'compact' ||
      this.printMode === 'compact_hybrid' || this.printMode === 'compact_hybrid_plus';
  }

  canRunPlanningPrint(): boolean {
    if (this.printPreparing || !this.printBatchNo) {
      return false;
    }
    if (this.printUseTemporary && this.getPlanningIncludedBatchItems().length === 0) {
      return false;
    }
    if (this.planningPrintNeedsEasel() && !this.selectedPrintEaselId) {
      return false;
    }
    if (this.printMode === 'bending_cnc' && !this.selectedBendingMachineId) {
      return false;
    }
    if ((this.printMode === 'profiles' || this.printMode === 'bending_cnc') &&
        this.printDoubleGlazingAvailabilityKnown && !this.printDoubleGlazingAvailable) {
      return false;
    }
    return true;
  }

  printPlanningBatch(): void {
    if ((this.printMode === 'profiles' || this.printMode === 'bending_cnc') &&
        this.printDoubleGlazingAvailabilityKnown && !this.printDoubleGlazingAvailable) {
      this.showMessage(
        'El listado de perfiles y el CNC de plegadora solo están disponibles para lotes que contengan posiciones de DOBLE ACRISTALAMIENTO.',
        'warning'
      );
      return;
    }
    if (!this.canRunPlanningPrint()) {
      return;
    }
    const pendingWindow = this.printMode === 'bending_cnc'
      ? null
      : this.reservePlanningPrintWindow();
    if (!this.printUseTemporary) {
      this.executePlanningPrint(false, pendingWindow);
      return;
    }

    this.printPreparing = true;
    this.optiService.previewProductionPlanningBatch({
      batchno: this.printBatchNo,
      source_batchno: this.creatingBatch ? null : this.originalBatchNo,
      items: this.getPlanningIncludedBatchItems().map(item => ({
        orderno: Number(item.orderno || 0),
        orderpos: Number(item.orderpos || 0)
      }))
    }).subscribe(response => {
      this.printPreparing = false;
      if (!response || response.ok !== true) {
        this.closePlanningPrintWindow(pendingWindow);
        this.showMessage(response && response.msg ? response.msg : 'No se ha podido preparar la impresión del lote.', 'danger');
        return;
      }
      this.executePlanningPrint(true, pendingWindow);
    });
  }

  private executePlanningPrint(useTemporaryIn: boolean, pendingWindowIn: Window): void {
    const batchNo = Number(this.printBatchNo || 0);
    const sourceTable = useTemporaryIn ? 'order_planned_tmp' : 'order_planned';
    const common = {
      back: 'production_planning',
      print_use_tmp: useTemporaryIn === true,
      source_table: sourceTable
    };
    let payload: any = null;

    if (this.printMode === 'profiles') {
      payload = Object.assign({}, common, {
        action: 'PrintAutoOptiProfiles',
        profiles_info: {
          lot_list: [batchNo],
          lots: batchNo.toString(),
          generated_at: new Date().toISOString(),
          user_name: localStorage.getItem('username') || '',
          include_grouped_profiles: this.printIncludeGroupedProfiles
        }
      });
    } else if (this.printMode === 'bending_cnc') {
      this.executeBendingMachineCnc(
        [batchNo],
        Number(this.selectedBendingMachineId),
        useTemporaryIn,
        null,
        false
      );
      return;
    } else if (this.printMode === 'route_dispatch') {
      payload = Object.assign({}, common, {
        action: 'PrintRouteExpedition',
        print_mode: this.printMode,
        batchno_list: [batchNo],
        easel_id: Number(this.selectedPrintEaselId)
      });
    } else if (this.printMode === 'compact' || this.printMode === 'compact_hybrid' || this.printMode === 'compact_hybrid_plus') {
      let compactMode = 'classic';
      if (this.printMode === 'compact_hybrid') {
        compactMode = 'hybrid_family';
      }
      if (this.printMode === 'compact_hybrid_plus') {
        compactMode = 'hybrid_family_plus';
      }
      this.printPreparing = true;
      this.optiService.compactOpti({
        opti_lot: batchNo.toString(),
        exact_lot: true,
        compact_mode: compactMode
      }).subscribe((compactInfo: any) => {
        this.printPreparing = false;
        if (!compactInfo || !compactInfo.order_opti || compactInfo.order_opti.length === 0) {
          this.closePlanningPrintWindow(pendingWindowIn);
          this.showMessage('No hay optimizaciones disponibles para generar la lista de compactación de este lote.', 'warning');
          return;
        }
        this.requestPlanningPdf({
          compact_list_info: compactInfo,
          easel_id: Number(this.selectedPrintEaselId),
          action: 'PrintCompactPile',
          back: 'production_planning'
        }, pendingWindowIn);
      });
      return;
    } else {
      payload = Object.assign({}, common, {
        action: 'PrintDivideLot',
        print_mode: this.printMode,
        compact_assoc_mode: 'no',
        easel_id: null,
        lot_info: {
          lot_0: batchNo,
          lot_1: batchNo,
          lot_2: null
        }
      });
    }

    this.requestPlanningPdf(payload, pendingWindowIn);
  }

  private reservePlanningPrintWindow(): Window {
    let pendingWindow: Window = null;
    try {
      pendingWindow = window.open('', '_blank');
      if (pendingWindow && pendingWindow.document) {
        pendingWindow.document.title = 'Preparando documento';
        pendingWindow.document.body.innerHTML =
          '<div style="font-family:Arial,sans-serif;padding:32px;color:#363636">' +
          '<h2 style="color:#209cee">Preparando documento…</h2>' +
          '<p>El visor se abrirá automáticamente cuando termine la generación.</p>' +
          '</div>';
      }
    } catch (error) {
      pendingWindow = null;
    }
    return pendingWindow;
  }

  private closePlanningPrintWindow(pendingWindowIn: Window): void {
    try {
      if (pendingWindowIn && !pendingWindowIn.closed) {
        pendingWindowIn.close();
      }
    } catch (error) {}
  }

  private requestPlanningPdf(payloadIn: any, pendingWindowIn: Window): void {
    this.printPreparing = true;
    this.fileService.printEasels(payloadIn).subscribe((response: any) => {
      this.printPreparing = false;
      if (!response || !response.section) {
        this.closePlanningPrintWindow(pendingWindowIn);
        this.showMessage(
          response && (response.message || response.error)
            ? (response.message || response.error)
            : 'El documento no se ha podido generar.',
          'danger'
        );
        return;
      }

      const viewerUrl = this.getPlanningDocumentViewerUrl(response.section, response.back);
      this.printModal = false;
      try {
        if (pendingWindowIn && !pendingWindowIn.closed) {
          pendingWindowIn.location.href = viewerUrl;
          return;
        }
      } catch (error) {}

      // Si el navegador impide reservar la pestaña, se utiliza la actual para garantizar que el PDF sea visible.
      window.location.href = viewerUrl;
    });
  }

  private getPlanningDocumentViewerUrl(sectionIn: string, backIn: string): string {
    const currentPage = window.location.href.split('#')[0];
    const section = encodeURIComponent(sectionIn || '');
    const back = encodeURIComponent(backIn || 'production_planning');
    return currentPage + '#/document/' + section + '/false/' + back;
  }

  private executeBendingMachineCnc(
    lotListIn: number[],
    machineIdIn: number,
    useTemporaryIn: boolean,
    manualCodesIn: any[] = null,
    applyManualCodesIn: boolean = false
  ): void {
    const selectedMachine = (this.bendingMachines || [])
      .find(item => Number(item && item.id || 0) === Number(machineIdIn));
    const stdDiscount = Number(selectedMachine && selectedMachine.std_profile_discount);
    if (!selectedMachine) {
      this.showMessage('No existe una plegadora disponible para generar el fichero CNC.', 'warning');
      return;
    }
    if (!Number.isFinite(stdDiscount) || stdDiscount <= 0) {
      this.showMessage(
        'La plegadora seleccionada tiene el descuento de perfil estándar a cero. Revíselo en Maestros > Plegadoras.',
        'warning'
      );
      return;
    }

    const payload: any = {
      action: 'CreateBendingCNC',
      back: 'production_planning',
      print_use_tmp: useTemporaryIn === true,
      source_table: useTemporaryIn === true ? 'order_planned_tmp' : 'order_planned',
      bending_info: {
        lot_list: lotListIn,
        lots: lotListIn.join(','),
        machine_id: Number(machineIdIn)
      }
    };
    if (manualCodesIn && manualCodesIn.length > 0) {
      payload.bending_info.manual_codes = manualCodesIn;
      payload.bending_info.apply_manual_codes = applyManualCodesIn === true;
    }

    this.printPreparing = true;
    this.fileService.printEasels(payload).subscribe((response: any) => {
      this.printPreparing = false;
      if (response && response.manual_required === true) {
        this.printModal = false;
        this.openBendingCodesModal(response, lotListIn, useTemporaryIn, machineIdIn);
        return;
      }
      if (response && response.content && response.file_name) {
        this.printModal = false;
        this.closeBendingCodesModal();
        this.downloadBendingFile(response.content, response.file_name);
        this.showMessage('Se ha generado correctamente el CNC de plegadora.', 'info');
        return;
      }
      this.showMessage(
        response && (response.error || response.message)
          ? (response.error || response.message)
          : 'No se ha podido generar el CNC de plegadora.',
        'danger'
      );
    });
  }

  private openBendingCodesModal(
    responseIn: any,
    lotListIn: number[],
    useTemporaryIn: boolean,
    machineIdIn: number
  ): void {
    const missing = responseIn && Array.isArray(responseIn.missing_profiles)
      ? responseIn.missing_profiles
      : [];
    this.bendingCodesMissingRows = missing.map(item => ({
      profile_key: item && item.profile_key ? item.profile_key.toString() : '',
      profile_label: item && item.profile_label ? item.profile_label.toString() : '-',
      slots: item && item.slots ? item.slots.toString() : '',
      code: ''
    }));
    this.bendingCodesLotList = (lotListIn || [])
      .map(item => Number(item))
      .filter(item => Number.isFinite(item) && item > 0);
    this.bendingCodesUseTemporary = useTemporaryIn === true;
    this.bendingCodesMachineId = Number(machineIdIn);
    this.bendingCodesModal = this.bendingCodesMissingRows.length > 0;
    if (!this.bendingCodesModal) {
      this.showMessage('No se han podido identificar los códigos de plegadora pendientes.', 'danger');
    }
  }

  closeBendingCodesModal(): void {
    if (this.printPreparing) {
      return;
    }
    this.bendingCodesModal = false;
    this.bendingCodesMissingRows = [];
    this.bendingCodesLotList = [];
    this.bendingCodesUseTemporary = false;
    this.bendingCodesMachineId = null;
  }

  confirmBendingCodesModal(): void {
    const validCode = /^[0-9A-Za-z]+$/;
    const manualCodes = [];
    for (const row of this.bendingCodesMissingRows) {
      const code = row && row.code !== undefined && row.code !== null
        ? row.code.toString().trim()
        : '';
      if (!code || !validCode.test(code)) {
        this.showMessage('Revise los códigos Lombarda. Solo se permiten letras y números.', 'warning');
        return;
      }
      manualCodes.push({
        profile_key: row.profile_key,
        profile: row.profile_label,
        code: code.toUpperCase()
      });
    }

    if (!this.bendingCodesMachineId || this.bendingCodesLotList.length === 0) {
      this.showMessage('No se ha podido recuperar el contexto para generar el CNC de plegadora.', 'danger');
      return;
    }
    const persistCodes = this.bendingCodesUseTemporary !== true &&
      window.confirm('¿Desea guardar estos códigos en el lote para futuras descargas?');
    this.executeBendingMachineCnc(
      this.bendingCodesLotList,
      this.bendingCodesMachineId,
      this.bendingCodesUseTemporary,
      manualCodes,
      persistCodes
    );
  }

  private downloadBendingFile(contentIn: string, fileNameIn: string): void {
    const blob = new Blob([contentIn], { type: 'application/octet-stream' });
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = fileNameIn ? fileNameIn.toString() : 'bending.job';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);
  }

  saveBatch(): void {
    if (!this.canModifyCurrentBatch()) {
      this.showCurrentBatchLockedMessage();
      return;
    }
    const batchNo = Number(this.editingBatchNo || 0);
    if (!Number.isInteger(batchNo) || batchNo <= 0) {
      this.showMessage('Introduzca un número de lote entero mayor que cero.', 'warning');
      return;
    }
    const includedItems = this.mode === 'classify'
      ? this.getPlanningIncludedBatchItems()
      : this.batchItems.slice();
    if (includedItems.length <= 0) {
      this.showMessage('Debe añadir al menos una posición al lote.', 'warning');
      return;
    }
    this.saving = true;
    this.optiService.createProductionPlanningBatch({
      batchno: batchNo,
      editing_batchno: this.creatingBatch ? null : this.originalBatchNo,
      items: includedItems.map(item => ({
        orderno: Number(item.orderno || 0),
        orderpos: Number(item.orderpos || 0)
      }))
    }).subscribe(response => {
      this.saving = false;
      if (!response || response.ok !== true) {
        this.showMessage(response && response.msg ? response.msg : 'No se ha podido guardar el lote.', 'danger');
        return;
      }
      this.showMessage('Lote ' + response.batchno + ' guardado con ' + includedItems.length + ' posición(es).', 'info');
      this.openEdit({ batchno: response.batchno });
    });
  }

  applyOptimizationInfoFromRows(rowsIn: any[]): void {
    const first = rowsIn && rowsIn.length > 0 ? rowsIn[0] : null;
    this.optimizationStatus = first && first.optimization_status ? first.optimization_status : 'no';
    this.requiredMaterials = first && first.required_materials ? Number(first.required_materials) : 0;
    this.optimizedMaterials = first && first.optimized_materials ? Number(first.optimized_materials) : 0;
    this.hasReadyMessages = !!(first && first.has_ready_messages);
    this.readyMessagesCount = first && first.ready_messages_count ? Number(first.ready_messages_count) : 0;
    this.readyStepsCount = first && first.ready_steps_count ? Number(first.ready_steps_count) : 0;
  }

  canModifyCurrentBatch(): boolean {
    return (!this.optimizationStatus || this.optimizationStatus === 'no') && !this.hasReadyMessages;
  }

  showOptimizedBatchMessage(): void {
    this.showMessage('Este lote tiene optimización ' + this.getOptimizationLabel() + '. Para modificarlo antes hay que borrar las optimizaciones asociadas al lote.', 'warning');
  }

  showCurrentBatchLockedMessage(): void {
    if (this.hasReadyMessages) {
      this.showReadyBatchMessage({
        batchno: this.editingBatchNo,
        ready_messages_count: this.readyMessagesCount,
        ready_steps_count: this.readyStepsCount
      });
      return;
    }
    this.showOptimizedBatchMessage();
  }

  hasBatchReadyMessages(rowIn: any): boolean {
    return !!(rowIn && rowIn.has_ready_messages);
  }

  showReadyBatchMessage(rowIn: any): void {
    const batchNo = Number(rowIn && rowIn.batchno || 0);
    const steps = Math.max(1, Number(rowIn && rowIn.ready_steps_count || 0));
    this.showMessage(
      'El lote ' + batchNo + ' ya ha recibido mensajes READY en ' + steps +
      ' paso(s). Para proteger los datos de producción no se puede modificar ni eliminar.',
      'warning'
    );
  }

  getOptimizationLabel(): string {
    if (this.optimizationStatus === 'completo') {
      return 'completa';
    }
    if (this.optimizationStatus === 'parcial') {
      return 'parcial';
    }
    return 'no';
  }

  getOptimizationClass(): string {
    if (this.optimizationStatus === 'completo') {
      return 'has-text-success';
    }
    if (this.optimizationStatus === 'parcial') {
      return 'has-text-warning';
    }
    return 'has-text-grey-dark';
  }

  getBatchTotalPositions(): number {
    return this.getBatchItemsForTotals().length;
  }

  getBatchDoubleGlazingPositions(rowIn: any): number {
    return Math.max(0, Number(rowIn && rowIn.double_glazing_positions_count || 0));
  }

  getBatchTripleGlazingPositions(rowIn: any): number {
    return Math.max(0, Number(rowIn && rowIn.triple_glazing_positions_count || 0));
  }

  getBatchProductTypes(rowIn: any): any[] {
    return rowIn && Array.isArray(rowIn.product_types) ? rowIn.product_types : [];
  }

  showEmergencyDoubleGlazingTag(rowIn: any): boolean {
    return this.getBatchProductTypes(rowIn).length === 0 &&
      this.getBatchDoubleGlazingPositions(rowIn) > 0 &&
      !this.showTripleGlazingTag(rowIn);
  }

  showTripleGlazingTag(rowIn: any): boolean {
    return this.getBatchTripleGlazingPositions(rowIn) > 0;
  }

  getBatchTripleGlazingTitle(rowIn: any): string {
    const positions = this.getBatchTripleGlazingPositions(rowIn);
    return 'Doble acristalamiento triple (tres vidrios y dos cámaras) · ' +
      positions + ' posición(es) en el lote';
  }

  getBatchShapePositions(rowIn: any): number {
    return Math.max(0, Number(rowIn && rowIn.has_shapes || 0));
  }

  showBatchShapesTag(rowIn: any): boolean {
    return this.getBatchShapePositions(rowIn) > 0;
  }

  getBatchShapesTitle(rowIn: any): string {
    const positions = this.getBatchShapePositions(rowIn);
    return positions + ' posición(es) con forma en el lote';
  }

  getBatchProductTypeTagClass(productTypeIn: any): string {
    const palette = ['is-info', 'is-primary', 'is-success', 'is-warning', 'is-link'];
    const value = productTypeIn && (productTypeIn.code || productTypeIn.name)
      ? (productTypeIn.code || productTypeIn.name).toString()
      : '';
    let hash = 0;
    for (let index = 0; index < value.length; index++) {
      hash = ((hash << 5) - hash) + value.charCodeAt(index);
      hash |= 0;
    }
    return palette[Math.abs(hash) % palette.length];
  }

  getBatchProductTypeTitle(productTypeIn: any): string {
    const code = productTypeIn && productTypeIn.code ? productTypeIn.code.toString() : '';
    const positions = Math.max(0, Number(productTypeIn && productTypeIn.positions_count || 0));
    return (code ? 'Código ' + code + ' · ' : '') + positions + ' posición(es) en el lote';
  }

  private resolveDoubleGlazingAvailability(batchNoIn: number, useTemporaryIn: boolean): boolean {
    if (useTemporaryIn || Number(this.editingBatchNo || 0) === Number(batchNoIn || 0)) {
      const items = useTemporaryIn ? this.getPlanningIncludedBatchItems() : (this.batchItems || []);
      if (items.length > 0) {
        return items.some(item => this.itemHasDoubleGlazingStep(item));
      }
    }

    const batchRow = (this.batchRows || []).find(row => Number(row && row.batchno || 0) === Number(batchNoIn || 0));
    if (batchRow && batchRow.double_glazing_positions_count !== undefined && batchRow.double_glazing_positions_count !== null) {
      return this.getBatchDoubleGlazingPositions(batchRow) > 0;
    }
    return null;
  }

  private itemHasDoubleGlazingStep(itemIn: any): boolean {
    const workSteps = itemIn && itemIn.work_steps ? itemIn.work_steps.toString().toUpperCase() : '';
    return workSteps.split(' - ').some(step => step.trim() === 'DOBLE ACRISTALAMIENTO');
  }

  getBatchTotalUnits(): number {
    return this.getBatchItemsForTotals().reduce((sum, item) => sum + Number(item && item.units || 0), 0);
  }

  getBatchTotalKg(): number {
    return this.getBatchItemsForTotals().reduce((sum, item) => sum + Number(item && item.kg_total || 0), 0);
  }

  getBatchTotalShapes(): number {
    return this.getBatchItemsForTotals().reduce((sum, item) => sum + Number(item && item.has_shapes || 0), 0);
  }

  private getBatchItemsForTotals(): any[] {
    return this.mode === 'classify'
      ? this.getPlanningIncludedBatchItems()
      : (this.batchItems || []);
  }

  getYesNo(valueIn: any): string {
    return valueIn === true || Number(valueIn || 0) > 0 ? 'S' : 'N';
  }

  previousBatchPage(): void {
    if (this.batchPage > 1) {
      this.searchBatches(this.batchPage - 1);
    }
  }

  nextBatchPage(): void {
    if (this.batchPage < this.getBatchTotalPages()) {
      this.searchBatches(this.batchPage + 1);
    }
  }

  getBatchTotalPages(): number {
    return Math.max(1, Math.ceil(Number(this.batchTotal || 0) / this.batchPageSize));
  }

  getDescription(rowIn: any): string {
    if (!rowIn) {
      return '';
    }
    return (rowIn.productdesc || rowIn.materialdesc || rowIn.materials || '').toString().trim();
  }

  getProductType(rowIn: any): string {
    return rowIn && rowIn.product_type_name ? rowIn.product_type_name.toString().trim() : '';
  }

  buildPendingProductTypesFromRows(rowsIn: any[]): any[] {
    const map = {};
    (rowsIn || []).forEach(row => {
      const code = row && row.product_definition_code ? row.product_definition_code.toString().trim() : '';
      const name = row && row.product_definition_name ? row.product_definition_name.toString().trim() : '';
      if (code && !map[code]) {
        map[code] = { code: code, name: name || code };
      }
    });
    return Object.keys(map).map(key => map[key]).sort((a, b) => a.name.localeCompare(b.name));
  }

  getReference(rowIn: any): string {
    const reference = rowIn && rowIn.reference !== null && rowIn.reference !== undefined
      ? rowIn.reference.toString().trim()
      : '';
    if (!reference || reference === (rowIn && rowIn.orderno ? rowIn.orderno.toString() : '')) {
      return '';
    }
    return reference;
  }

  getInfoAddDisplay(rowIn: any): string {
    if (!rowIn) {
      return '';
    }
    const metadata = this.getInfoAddMetadata(rowIn);
    if (!metadata) {
      return rowIn.info_add !== null && rowIn.info_add !== undefined
        ? rowIn.info_add.toString().trim()
        : '';
    }

    const parts: string[] = [];
    const documentCode = metadata.document && metadata.document.code
      ? metadata.document.code.toString().trim()
      : '';
    const route = metadata.delivery_route || {};
    const routeNumber = route.number !== null && route.number !== undefined
      ? route.number.toString().trim()
      : '';
    const routeName = route.name ? route.name.toString().trim() : '';
    const routeText = [routeNumber, routeName].filter(item => item !== '').join(' - ');

    if (documentCode) {
      parts.push('Pedido: ' + documentCode);
    }
    if (routeText) {
      parts.push('Ruta: ' + routeText);
    }

    const profiles = Array.isArray(metadata.spacer_profiles)
      ? metadata.spacer_profiles
      : [];
    profiles.forEach((profile, index) => {
      const slot = profile && profile.slot
        ? profile.slot.toString().trim()
        : ('PF' + (index + 1));
      const label = this.getInfoAddComponentLabel(profile);
      if (label) {
        parts.push(slot + ': ' + label);
      }
    });

    const manufacturing = Array.isArray(metadata.manufacturing)
      ? metadata.manufacturing
      : [];
    const manufacturingLabels = manufacturing
      .map(item => this.getInfoAddComponentLabel(item))
      .filter(item => item !== '');
    if (manufacturingLabels.length > 0) {
      parts.push('Manufactura: ' + manufacturingLabels.join(', '));
    }
    if (metadata.notes && metadata.notes.toString().trim() !== '') {
      parts.push('Notas: ' + metadata.notes.toString().trim());
    }
    return parts.join(' · ');
  }

  private getInfoAddMetadata(rowIn: any): any {
    const provided = rowIn && rowIn.info_add_data;
    if (provided && typeof provided === 'object' && !Array.isArray(provided)) {
      return provided;
    }
    const raw = rowIn && rowIn.info_add !== null && rowIn.info_add !== undefined
      ? rowIn.info_add.toString().trim()
      : '';
    if (!raw || raw.charAt(0) !== '{') {
      return null;
    }
    try {
      const parsed = JSON.parse(raw);
      return parsed && parsed.schema === 'dimpro.order-planned-info'
        ? parsed
        : null;
    } catch (error) {
      return null;
    }
  }

  private getInfoAddComponentLabel(componentIn: any): string {
    if (!componentIn) {
      return '';
    }
    const name = componentIn.name ? componentIn.name.toString().trim() : '';
    const description = componentIn.description ? componentIn.description.toString().trim() : '';
    const reference = componentIn.reference ? componentIn.reference.toString().trim() : '';
    const base = name || description || reference;
    if (name && description && name.toLocaleLowerCase() !== description.toLocaleLowerCase()) {
      return name + ' (' + description + ')';
    }
    return base;
  }

  getDimensions(rowIn: any): string {
    if (!rowIn) {
      return '';
    }
    const width = Number(rowIn.width || 0);
    const height = Number(rowIn.height || 0);
    if (!width && !height) {
      return '';
    }
    return this.formatNumber(width) + ' x ' + this.formatNumber(height);
  }

  showPlanningHelp(valueIn: boolean): void {
    this.planningHelpModal = valueIn;
    if (valueIn) {
      this.planningHelpSection = 'flujo';
    } else {
      this.closePlanningHelpImage();
    }
  }

  setPlanningHelpSection(sectionIn: string): void {
    this.planningHelpSection = sectionIn;
  }

  isPlanningHelpSection(sectionIn: string): boolean {
    return this.planningHelpSection === sectionIn;
  }

  openPlanningHelpImage(srcIn: string, titleIn: string): void {
    this.planningHelpImageSrc = srcIn || '';
    this.planningHelpImageTitle = titleIn || 'Ejemplo visual de planificación';
    this.planningHelpImageModal = !!this.planningHelpImageSrc;
  }

  closePlanningHelpImage(): void {
    this.planningHelpImageModal = false;
    this.planningHelpImageSrc = '';
    this.planningHelpImageTitle = '';
  }

  getPlanningTourSteps(): Array<{
    title: string,
    body: string,
    targetId: string,
    images?: Array<{src: string, title: string, caption: string}>
  }> {
    if (this.mode === 'classify') {
      return [
        {
          title: 'Elegir el modo de ordenación',
          body: 'Pulsa Ordenar para conservar la selección manual, combinar criterios con prioridad, ordenar por dificultad de corte o agrupar por pasos de trabajo.',
          targetId: 'planningTourClassification'
        },
        {
          title: 'Comprobar las claves visuales',
          body: 'Los tags superiores resumen el criterio aplicado y la columna Claves muestra los valores concretos que han determinado la posición de cada línea.',
          targetId: 'planningTourClassification'
        },
        {
          title: 'Imprimir o grabar',
          body: 'Imprimir prepara una copia temporal con esta secuencia. Grabar lote persiste finalmente el orden mostrado en la columna Seq.',
          targetId: 'planningTourHeaderActions'
        }
      ];
    }

    if (this.mode === 'edit') {
      return [
        {
          title: 'Identificar y filtrar el lote',
          body: 'Aquí se muestra el número de lote elegido. El filtro de tipo de producto limita los pedidos y posiciones pendientes para trabajar por familias de fabricación.',
          targetId: 'planningTourBatchSetup'
        },
        {
          title: 'Revisar la composición del lote',
          body: 'Esta tabla contiene las posiciones que formarán el lote y su secuencia definitiva. El resumen inferior permite comprobar unidades, kilos, formas y estado de optimización o producción.',
          targetId: 'planningTourBatchItems'
        },
        {
          title: 'Añadir pedidos completos',
          body: 'Marca uno o varios pedidos, o selecciónalos todos, y pulsa Añadir selección. Marcar un pedido también muestra inmediatamente sus posiciones en la zona inferior.',
          targetId: 'planningTourPendingOrders'
        },
        {
          title: 'Añadir posiciones concretas',
          body: 'Cuando no quieras incorporar el pedido completo, selecciona únicamente sus posiciones necesarias. Las ya incorporadas quedan desactivadas para evitar duplicados.',
          targetId: 'planningTourPendingPositions'
        },
        {
          title: 'Clasificar o volver',
          body: 'Clasificar lote abre la vista donde se decide la secuencia, se imprimen los formularios y finalmente se graba. Volver abandona el editor.',
          targetId: 'planningTourHeaderActions'
        }
      ];
    }

    return [
      {
        title: 'Buscar lotes de producción',
        body: 'Filtra por número de lote, cliente o intervalo de fechas. La paginación permite recorrer el histórico sin cargar todos los lotes a la vez.',
        targetId: 'planningTourBatchFilters'
      },
      {
        title: 'Interpretar y gestionar los lotes',
        body: 'La tabla resume planificación, clientes, pedidos, posiciones, formas, superficie y peso. Sus acciones permiten consultar auditoría, estado de producción, buscar automáticamente las optimizaciones del lote, imprimir, editar o eliminar cuando sea seguro.',
        targetId: 'planningTourBatchList'
      },
      {
        title: 'Crear un lote nuevo',
        body: 'Crear lote propone el siguiente número libre, aunque puedes escribir otro entero positivo. Antes de continuar se comprueba que no exista ni esté vinculado a producción. Al aceptar se abre el editor, pero el lote todavía no se graba: debes añadir pedidos completos o posiciones concretas, clasificar la secuencia y finalizar con Grabar lote. Si vuelves al listado sin grabar, esa preparación se pierde.',
        targetId: 'planningTourHeaderActions',
        images: [
          {
            src: './assets/help/production-planning/pedidos-pendientes.png',
            title: 'Selección de pedidos sin planificar',
            caption: 'Selecciona uno, varios o todos los pedidos pendientes. Activar un pedido muestra sus posiciones.'
          },
          {
            src: './assets/help/production-planning/posiciones-pedido.png',
            title: 'Selección de posiciones concretas',
            caption: 'Si no quieres añadir el pedido completo, selecciona únicamente las posiciones necesarias.'
          }
        ]
      }
    ];
  }

  getCurrentPlanningTourStep(): {
    title: string,
    body: string,
    targetId: string,
    images?: Array<{src: string, title: string, caption: string}>
  } {
    const steps = this.getPlanningTourSteps();
    if (this.planningTourIndex < 0) {
      this.planningTourIndex = 0;
    }
    if (this.planningTourIndex >= steps.length) {
      this.planningTourIndex = steps.length - 1;
    }
    return steps[this.planningTourIndex];
  }

  startPlanningTour(): void {
    this.showPlanningHelp(false);
    this.closePlanningTour();
    this.planningTourIndex = 0;
    this.setDefaultPlanningTourPosition();
    this.planningTourModal = true;
    window.addEventListener('resize', this.planningTourViewportHandler);
    window.addEventListener('scroll', this.planningTourViewportHandler, true);
    document.addEventListener('keydown', this.planningTourKeydownHandler);
    this.focusPlanningTourTarget();
  }

  closePlanningTour(): void {
    this.planningTourModal = false;
    if (this.planningTourViewportHandler) {
      window.removeEventListener('resize', this.planningTourViewportHandler);
      window.removeEventListener('scroll', this.planningTourViewportHandler, true);
    }
    if (this.planningTourKeydownHandler) {
      document.removeEventListener('keydown', this.planningTourKeydownHandler);
    }
  }

  nextPlanningTourStep(): void {
    const steps = this.getPlanningTourSteps();
    if (this.planningTourIndex < steps.length - 1) {
      this.planningTourIndex += 1;
      this.focusPlanningTourTarget();
      return;
    }
    this.closePlanningTour();
  }

  previousPlanningTourStep(): void {
    if (this.planningTourIndex > 0) {
      this.planningTourIndex -= 1;
      this.focusPlanningTourTarget();
    }
  }

  private focusPlanningTourTarget(): void {
    const step = this.getCurrentPlanningTourStep();
    if (!step || !step.targetId) {
      return;
    }

    setTimeout(() => {
      const target = document.getElementById(step.targetId);
      if (!target) {
        this.setDefaultPlanningTourPosition();
        return;
      }
      target.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      setTimeout(() => this.positionPlanningTourNearElement(target), 360);
    }, 80);
  }

  positionPlanningTourForCurrentStep(): void {
    const step = this.getCurrentPlanningTourStep();
    const target = step && step.targetId ? document.getElementById(step.targetId) : null;
    if (!target) {
      this.setDefaultPlanningTourPosition();
      return;
    }
    this.positionPlanningTourNearElement(target);
  }

  private positionPlanningTourNearElement(targetIn: HTMLElement): void {
    const rect = targetIn.getBoundingClientRect();
    const viewportWidth = window.innerWidth || 1280;
    const viewportHeight = window.innerHeight || 800;
    const targetPadding = 8;
    const viewportPadding = 12;
    const gap = 22;
    const currentStep = this.getCurrentPlanningTourStep();
    const hasImages = !!(currentStep && currentStep.images && currentStep.images.length);
    const desiredCardWidth = hasImages ? 760 : 430;
    const cardWidth = Math.min(desiredCardWidth, Math.max(300, viewportWidth - (viewportPadding * 2)));
    const cardElement = document.getElementById('productionPlanningTourCard');
    const cardHeight = cardElement && cardElement.offsetHeight ? cardElement.offsetHeight : 245;

    const spotlightLeft = Math.max(viewportPadding, rect.left - targetPadding);
    const spotlightTop = Math.max(viewportPadding, rect.top - targetPadding);
    const spotlightRight = Math.min(viewportWidth - viewportPadding, rect.right + targetPadding);
    const spotlightBottom = Math.min(viewportHeight - viewportPadding, rect.bottom + targetPadding);
    this.planningTourSpotlightStyle = {
      left: Math.round(spotlightLeft) + 'px',
      top: Math.round(spotlightTop) + 'px',
      width: Math.max(20, Math.round(spotlightRight - spotlightLeft)) + 'px',
      height: Math.max(20, Math.round(spotlightBottom - spotlightTop)) + 'px'
    };

    const rightSpace = viewportWidth - rect.right;
    const leftSpace = rect.left;
    const belowSpace = viewportHeight - rect.bottom;
    const aboveSpace = rect.top;
    let top = viewportPadding;
    let left = viewportPadding;

    if (rightSpace >= cardWidth + gap) {
      this.planningTourPlacement = 'right';
      left = rect.right + gap;
      top = rect.top + (rect.height / 2) - (cardHeight / 2);
    } else if (leftSpace >= cardWidth + gap) {
      this.planningTourPlacement = 'left';
      left = rect.left - cardWidth - gap;
      top = rect.top + (rect.height / 2) - (cardHeight / 2);
    } else if (belowSpace >= cardHeight + gap || belowSpace >= aboveSpace) {
      this.planningTourPlacement = 'bottom';
      left = rect.left + (rect.width / 2) - (cardWidth / 2);
      top = rect.bottom + gap;
    } else {
      this.planningTourPlacement = 'top';
      left = rect.left + (rect.width / 2) - (cardWidth / 2);
      top = rect.top - cardHeight - gap;
    }

    left = Math.max(viewportPadding, Math.min(left, viewportWidth - cardWidth - viewportPadding));
    top = Math.max(viewportPadding, Math.min(top, viewportHeight - cardHeight - viewportPadding));
    this.planningTourCardStyle = {
      width: Math.round(cardWidth) + 'px',
      left: Math.round(left) + 'px',
      top: Math.round(top) + 'px'
    };
  }

  private setDefaultPlanningTourPosition(): void {
    const viewportWidth = window.innerWidth || 1280;
    const currentStep = this.getCurrentPlanningTourStep();
    const hasImages = !!(currentStep && currentStep.images && currentStep.images.length);
    const cardWidth = Math.min(hasImages ? 760 : 430, Math.max(300, viewportWidth - 24));
    this.planningTourPlacement = 'none';
    this.planningTourSpotlightStyle = {
      left: '50%',
      top: '50%',
      width: '1px',
      height: '1px'
    };
    this.planningTourCardStyle = {
      width: cardWidth + 'px',
      left: Math.max(12, (viewportWidth - cardWidth) / 2) + 'px',
      top: '24px'
    };
  }

  showMessage(messageIn: string, skinIn: string): void {
    this.message = messageIn || '';
    this.messageSkin = skinIn || 'info';
  }

  formatDate(valueIn: any): string {
    if (!valueIn) {
      return '';
    }
    const date = new Date(valueIn);
    if (isNaN(date.getTime())) {
      return '';
    }
    return date.toLocaleDateString('es-ES');
  }

  formatDateTime(valueIn: any): string {
    if (!valueIn) {
      return '';
    }
    const date = new Date(valueIn);
    if (isNaN(date.getTime())) {
      return '';
    }
    return date.toLocaleDateString('es-ES') + ' ' + date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
  }

  getDateInputValue(offsetDaysIn: number): string {
    const date = new Date();
    date.setDate(date.getDate() + Number(offsetDaysIn || 0));
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return year + '-' + month + '-' + day;
  }

  formatNumber(valueIn: any, decimalsIn: number = 0): string {
    const value = Number(valueIn || 0);
    if (!Number.isFinite(value)) {
      return '0';
    }
    return value.toLocaleString('es-ES', {
      minimumFractionDigits: decimalsIn,
      maximumFractionDigits: decimalsIn
    });
  }
}
